import { z } from 'zod';

export const addressFormSchema = z.object({
  address: z.object({
    city: z.string({ message: 'form.errors.required' }).min(1, {
      message: 'form.errors.required',
    }),
    line1: z.string({ message: 'form.errors.required' }).min(1, {
      message: 'form.errors.required',
    }),
    line2: z.string().optional(),
    postalCode: z
      .string({
        message: 'form.errors.required',
      })
      .min(1, {
        message: 'form.errors.required',
      }),
  }),
});

export type AddressFormValues = z.infer<typeof addressFormSchema>;
